import React from "react";
import { useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./scss/style.scss";
import { loadUserFromStorage } from "./services/AuthenticationService";
import store from "./store";
import AuthProvider from "./components/authProvider";
import userManager from "./services/AuthenticationService";
import { useDispatch } from "react-redux";
import { getTicketType } from "./actions/filterActions";
import { storeUserInterfaceInfo } from "./actions/uiAction";
import { isMobile } from "react-device-detect";
// import FloatingButton from "./features/FloatingButton";

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");

// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));
const FloatingButton = React.lazy(() => import("./features/FloatingButton"));
const Login = React.lazy(() => import("./views/account/login/Login"));
const Logout = React.lazy(() => import("./views/account/logout/Logout"));
const SigninOidc = React.lazy(() => import("./views/account/login/SigninOidc"));
const SignoutOidc = React.lazy(() =>
  import("./views/account/logout/SignoutOidc")
);
const ResetPassword = React.lazy(() =>
  import("./views/account/reset-password/ResetPassword")
);const LoginVerification = React.lazy(() =>
  import("./views/account/login-verification/LoginVerification")
);
const CitizensPortal = React.lazy(() =>
  import("./views/citizens-portal/CitizensPortal")
);
const TransactionLandingPage = React.lazy(() =>
  import("./views/citizens-portal/TransactionLandingPage")
);

function App() {
  const dispatch = useDispatch();
  useEffect(() => {
    loadUserFromStorage(store);
    dispatch(getTicketType());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  dispatch(storeUserInterfaceInfo({ isMobile: isMobile }));

  return (
    <AuthProvider userManager={userManager} store={store}>
      <BrowserRouter basename={baseUrl}>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route exact path="/reset-password" component={ResetPassword} />
            <Route exact path="/multiple-login-detected" component={LoginVerification} />
            <Route exact path="/citizens-portal" component={CitizensPortal} />
            {/* <Route
              exact
              path="/citizens-portal/:id"
              component={CitizensPortalViolationDetails}
            /> */}
            <Route
              exact
              path={"/transaction-complete"}
              component={TransactionLandingPage}
            />
            <Route path="/login" component={Login} />
            <Route path="/logout" component={Logout} />
            <Route path="/signout-oidc" component={SignoutOidc} />
            <Route path="/signin-oidc" component={SigninOidc} />
            <Route
              path="/"
              name="Home"
              render={(props) => (
                <>
                  <TheLayout {...props} />
                  <FloatingButton />
                </>
              )}
            />
          </Switch>
        </React.Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
